import {
  MINDMAP_VIEW,
  NARRATIVE_VIEW,
  OUTLINE_VIEW,
  RELATIONSHIP_VIEW,
  SPREADSHEET_VIEW,
  SUBWAY_VIEW,
  TIMELINE_VIEW
} from "../../constants/identifiers";
import mindmapViewSelectors from "../../features/mindmapView/selectors";
import narrativeViewSelectors from "../../features/narrativeView/selectors";
import outlineViewSelectors from "../../features/outlineView/selectors";
import relationshipViewSelectors from "../../features/relationshipView/selectors";
import spreadsheetViewSelectors from "../../features/spreadsheetView/selectors";
import subwayViewSelectors from "../../features/subwayView/selectors";
import timelineViewSelectors from "../../features/timelineView/selectors";
import { appStateSelectors } from "../../modules/appState";

const isViewPrintable = (state, activeView) => {
  const viewId = activeView.viewId;
  const viewType = activeView.viewType;
  switch (viewType) {
    case MINDMAP_VIEW:
      return mindmapViewSelectors.getMindmapViewData(state, viewId).nodes.size > 0;
    case TIMELINE_VIEW:
      return timelineViewSelectors.getTimelineViewData(state, viewId).sortedEventIds.size > 0;
    case SPREADSHEET_VIEW:
      // Empty row included
      return spreadsheetViewSelectors.getSpreadsheetViewData(state, viewId).rows.size > 1;
    case OUTLINE_VIEW:
      // Empty row included
      return outlineViewSelectors.getOutlineViewData(state, viewId).rows.size > 1;
    case NARRATIVE_VIEW:
      return narrativeViewSelectors.getNarrativeViewData(state, viewId).cards.size > 0;
    case SUBWAY_VIEW:
      return subwayViewSelectors.getSubwayViewData(state, viewId).threads.size > 0;
    case RELATIONSHIP_VIEW: {
      return relationshipViewSelectors.doesRelationshipViewHaveData(state, viewId);
    }
    default:
      return false;
  }
};

const getActiveViewIsPrintable = state => {
  // If there is no data loaded yet, nothing is printable
  if (!state.isDataLoaded) {
    return false;
  }
  const activeView = appStateSelectors.getActiveView(state);
  return isViewPrintable(state, activeView);
};

export { getActiveViewIsPrintable };
